import { useState } from "react";
import { useAppSelector } from "../../../../hooks";
import { helpers } from "../../../../packages/helpers";
import {
  selectAuthorList,
  selectChatMessages,
  selectChatSettings,
} from "../../selectors";

const { isMessageReceived, isAuthorOpponent } = helpers.predicates;
const OFFSET = 3;

export const useMessagesNew = () => {
  const [firstUnreadMessageId, setFirstUnreadMessageId] = useState<
    string | null
  >(null);

  const allMessages = useAppSelector(selectChatMessages);
  const authors = useAppSelector(selectAuthorList);
  const { lastReadMessageIndex } = useAppSelector(selectChatSettings);

  const handleShowServiceMessageNew = () => {
    if (firstUnreadMessageId) {
      return;
    }

    const slicedMessages = allMessages.slice(lastReadMessageIndex - OFFSET);
    const firstUnreadMessage = slicedMessages.find(
      ({ status, authorId }) =>
        isMessageReceived(status) && isAuthorOpponent(authors[authorId]?.role)
    );

    if (firstUnreadMessage) {
      setFirstUnreadMessageId(firstUnreadMessage.id);
    }
  };

  const handleHideServiceMessageNew = () => {
    setFirstUnreadMessageId(null);
  };

  return {
    firstUnreadMessageId,
    handleShowServiceMessageNew,
    handleHideServiceMessageNew,
  };
};
